// Module
var code = `<div id="reply-offices-popup" class="reply-popup-container hidden" style="background-color: #151F27; color: white"><button class="button-anchor close-anchor">X</button><div id="reply-offices-popup-content"></div></div>`;
// Exports
export default code;